import { Screen, Card } from './components/ui.js';

/**
 * Everything used to fall through to the player app, so a mistyped or guessed
 * address quietly served a plausible wrong page. A guess that looks like it
 * worked is worse than one that plainly did not.
 */
export function NotFound({ path }: { path: string }) {
  const places = [
    { href: '/', label: 'Playing tonight', detail: 'Join the quiz' },
    { href: '/staff', label: 'Host or door staff', detail: 'Sign in with your PIN' },
    { href: '/print', label: 'Run sheet', detail: 'Printable paperwork for the night' },
    { href: '/admin', label: 'Quiz builder', detail: 'Write questions (admin token)' },
  ];

  return (
    <Screen>
      <div className="flex flex-1 flex-col justify-center gap-4">
        <Card>
          <p className="text-xs uppercase tracking-wide text-muted">No such page</p>
          <p className="mt-1 break-all text-2xl font-bold">{path}</p>
          <p className="mt-3 text-muted">You probably want one of these.</p>
        </Card>

        <nav className="space-y-2">
          {places.map((p) => (
            <a
              key={p.href}
              href={p.href}
              className="flex min-h-14 items-center gap-3 rounded-xl bg-ink-2 px-4 hover:bg-ink-3"
            >
              <span className="flex-1">
                <span className="block font-semibold">{p.label}</span>
                <span className="block text-sm text-muted">{p.detail}</span>
              </span>
              <span className="font-mono text-sm text-sky">{p.href}</span>
            </a>
          ))}
        </nav>
      </div>
    </Screen>
  );
}
